import React from 'react';
import { Button } from './ui/button';
import { Server, Smartphone, LogOut, Share } from 'lucide-react';

interface NavbarProps {
  userPhone: string;
  currentView: 'dashboard' | 'broadcast';
  onLogout: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ userPhone, currentView, onLogout }) => {
  const getTitle = () => {
    switch (currentView) {
      case 'broadcast':
        return {
          icon: <Share className="h-6 w-6 mr-2" />,
          title: 'Kirim Link'
        };
      default:
        return {
          icon: <Server className="h-6 w-6 mr-2" />,
          title: 'Alamat Modal LGP'
        };
    }
  };

  const { icon, title } = getTitle();

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-700 text-white">
      <div className="px-4 py-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center">
            {icon}
            <span className="font-bold text-lg">{title}</span>
          </div>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onLogout} 
            className="text-white hover:bg-white/20 p-2"
          >
            <LogOut className="h-5 w-5" />
          </Button>
        </div>
        <div className="flex items-center text-sm opacity-90">
          <Smartphone className="h-4 w-4 mr-2" />
          <span>{userPhone}</span>
        </div>
      </div>
    </div>
  );
};

export default Navbar;